<template>
  <v-layout>

    <v-flex>
      <v-row align="center" no-gutters class="">
        <v-col class="text-left ml-n6 mt-n4">
          <v-breadcrumbs :items="subNavs"></v-breadcrumbs>
        </v-col>
      </v-row>

      <v-card class="pa-6 mt-3">
        <v-card-title>
          {{ forUpdate ? 'Update' : 'Add New' }} Client
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text class="text--primary mt-6">

          <AlertMessage :alerMessage="alerMessage"></AlertMessage>

          <ValidationObserver ref="observer" v-slot="{ validate, reset }">
            <form
              v-on:submit.prevent>
              <v-row class="pb-5">
                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="user.sales_agent"
                    :items="agents"
                    :loading="loading"
                    :search-input.sync="search"
                    clearable
                    no-data-text="Client not found"
                    hide-details
                    hide-selected
                    item-text="keyword"
                    outlined
                    label="Assign To"
                    item-value="id"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          Enter <strong>Name</strong>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <div
                        v-bind="attr"
                        :input-value="selected"
                        color="#A3A8AD"
                        v-on="on">
                          <span v-text="item.first_name + ' ' + item.last_name"></span>
                          <span v-text="item.code" v-if="item.code" class="grey-color ml-2"></span>
                      </div>

                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.first_name + ' ' + item.last_name"></v-list-item-title>
                        <v-list-item-subtitle v-text="item.code"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row class="pa-0">
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="user.code"
                    maxlength="100"
                    label="Code"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <ValidationProvider v-slot="{ errors }" name="First Name" rules="required|max:100">
                    <v-text-field
                      v-model="user.first_name"
                      maxlength="100"
                      :error-messages="errors"
                      label="First Name"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="4">
                  <ValidationProvider v-slot="{ errors }" name="Last Name" rules="required|max:100">
                    <v-text-field
                      v-model="user.last_name"
                      maxlength="100"
                      :error-messages="errors"
                      label="Last Name"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="4">
                  <ValidationProvider v-slot="{ errors }" name="Email Address" rules="required|email">
                    <v-text-field
                      v-model="user.email"
                      maxlength="100"
                      :error-messages="errors"
                      label="Email Address"
                      hint="* Required (e.g. juan.delacruz@email.com)"
                      show-details
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="user.contact_no"
                    maxlength="50"
                    label="Contact No."
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="user.company"
                    maxlength="150"
                    label="Company"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <ValidationProvider v-slot="{ errors }" name="Overseas Warehouse" rules="required">
                    <v-select
                      v-model="user.location_id"
                      :items="locations"
                      menu-props="auto"
                      :error-messages="errors"
                      label="Overseas Warehouse"
                      item-text="name"
                      item-value="id"
                      required
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="4">
                  <ValidationProvider v-slot="{ errors }" name="Warehouse" rules="required">
                    <v-select
                      v-model="user.warehouse_id"
                      :items="warehouses"
                      menu-props="auto"
                      :error-messages="errors"
                      label="Warehouse"
                      item-text="name"
                      item-value="id"
                      required
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="4">
                  <v-textarea
                    v-model="user.address"
                    label="Address"
                    auto-grow
                    rows="1"
                    maxlength="255"
                    value="">
                  </v-textarea>
                </v-col>
                <v-col cols="12" md="4">
                  <ValidationProvider v-slot="{ errors }" name="Status" rules="required">
                    <v-select
                      v-model="user.status"
                      :items="statuses"
                      menu-props="auto"
                      :error-messages="errors"
                      label="Status"
                      item-text="name"
                      item-value="id"
                      required
                    ></v-select>
                  </ValidationProvider>
                </v-col>                
                <v-col cols="12" md="4">
                  <v-switch
                    v-model="user.bill_to_company"
                    label="Bill to Company?"
                    class="mb-4"
                  ></v-switch>
                </v-col>


              </v-row>
              <v-btn class="d-none" @click="reset"></v-btn>
            </form>
          </ValidationObserver>

        </v-card-text>
        <v-card-title v-if="getCurrentUser.code === 'ADMIN'">
          <v-text-field
            v-model="resetLink"
            label="Reset Link"
            class="mr-2"
            readonly
          ></v-text-field>
          <div class="d-flex">
            <v-btn
              depressed
              large
              :disabled="copied"
              @click="copyLink">
              <span class="mx-4">
                <template v-if="copied">Copied!</template>
                <template v-else>Copy</template>              
              </span>
            </v-btn>
            <v-btn
              color="primary ml-2"
              depressed
              large
              @click="resetPass">
              <span class="mx-4">
                <template v-if="resetting">Resetting password...</template>
                <template v-else>Reset Password</template>              
              </span>
            </v-btn>
          </div>          
        </v-card-title>
        <v-card-actions>
          <v-btn
            color="primary mr-4"
            depressed
            large
            @click="submit">
            <span class="mx-4">
              {{ loading ? 'Please wait...' : '' }}
              {{ !loading ? forUpdate ? 'Update Client' : 'Add Client' : '' }}
            </span>
          </v-btn>
          <v-btn
            v-if="!loading"
            depressed
            large
            @click="clear">
            <span class="mx-4">Reset Form</span>
          </v-btn>
        </v-card-actions>
      </v-card>

      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>

    </v-flex>
  </v-layout>
</template>

<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import { mapGetters } from "vuex"
  import { required, email, max } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import AlertMessage from '@/components/AlertMessage.vue'

  setInteractionMode('eager')

  extend('required', {
    ...required,
    message: '{_field_} can not be empty',
  })

  extend('max', {
    ...max,
    message: '{_field_} may not be greater than {length} characters',
  })

  extend('email', {
    ...email,
    message: '{_field_} must be a valid email',
  })

  export default {
    name: 'UpdateClientPage',
    data: () => ({
      adminNamespace: 'admin',
      slug: '',
      search: null,
      show1: false,
      loading: false,
      copied: false,
      resetting: false,
      resetLink: '',
      subNavs: [
        {
          text: 'Clients',
          disabled: false,
          exact: true,
          to: {
            name: 'clients'
          },
        },
        {
          text: 'Add New Client',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      alerMessage:{
        show: false,
        status: '',
        type: 'error',
        omitMessage: '',
        messages: []
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      agents: [],
      warehouses: [],
      locations: [],
      statuses: [],
      user: {
        email: '',
        sales_agent: '',
        first_name: '',
        last_name: '',
        contact_no: '',
        warehouse_id: '',
        location_id: '',
        address: '',
        company: '',
        bill_to_company: false
      }
    }),
    computed: {
      forUpdate: function(){
        return this.slug ? true : false
      },
      ...mapGetters(['getCurrentUser'])
    },
    methods: {
      resetPass () {
        if (this.resetting) return false

        this.copied = false
        this.resetting = true
        let self = this

        let userData = {
          email: this.user.email
        }

        this.$http.secured.post(this.adminNamespace+'/clients/reset-pass', userData)
          .then(response => {
            console.log(response.data);
            this.resetLink = response.data.resetLink            
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.resetting = false
          })
        
      },
      copyLink () {
        this.copied = true
        navigator.clipboard.writeText(this.resetLink)
      },
      getDefaultData () {
        let self = this
        this.$http.plain.get(this.adminNamespace+'/default-data?agents=true&warehouses=true&locations=true&user_statuses=true')
          .then(response => {
            this.agents = response.data.agents
            this.warehouses = response.data.warehouses
            this.locations = response.data.locations
            this.statuses = response.data.user_statuses
          })
          .catch(error => {
            console.log(error);
          })
      },
      getClient () {
        this.loading = true
        let self = this
        this.$http.plain.get(this.adminNamespace+'/clients/'+this.slug)
          .then(response => {
            this.user = response.data
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      addNew () {
        let self = this

        this.$http.secured.post(this.adminNamespace+'/clients', this.user)
          .then(response => {
            this.$router.push({ name: 'clients', query: { added: true, message: "Client has been successfully added" } })
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      update () {
        let self = this
        this.$http.secured.put(this.adminNamespace+'/clients/'+this.slug, this.user)
          .then(response => {
            this.getClient()
            this.alerMessage.show = false
            this.showMessage("Client has been successfully updated", 'success')
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })

      },
      async submit () {

        const isValid = await this.$refs.observer.validate();
        if (!isValid) {
          return false;
        }

        if(this.loading){
          return false;
        }

        this.loading = true

        if(this.forUpdate){
          this.update()
        }else{
          this.addNew()
        }
      },
      clear () {
        Object.keys(this.user).forEach(key => {
          this.user[key] = ''
        })

        this.$refs.observer.reset()

        if(this.forUpdate){
          this.getClient()
        }
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      }
    },
    mounted() {
      if(this.$route.params.slug != 'add'){

        this.subNavs[1].text = 'Update Client'
        this.slug = this.$route.params.slug
        this.getClient()
      }

      this.getDefaultData()
    },
    components: {
      ValidationProvider,
      ValidationObserver,
      SnackBar,
      AlertMessage
    }
  }
</script>
